// test2159
(2159 && 0);
